// extracted by mini-css-extract-plugin
module.exports = {"drawer":"SideBar_drawer__3prCO","clear":"SideBar_clear__2cBHv"};